import { render } from "./ContactosView.vue?vue&type=template&id=70e07ef8&scoped=true"
import script from "./ContactosView.vue?vue&type=script&lang=js"
export * from "./ContactosView.vue?vue&type=script&lang=js"

import "./ContactosView.vue?vue&type=style&index=0&id=70e07ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e07ef8"]])

export default __exports__